<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="客户姓名：">
            <el-input v-model="query.customerName" placeholder="请输入客户姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="客户电话：">
            <el-input v-model="query.customerPhone" placeholder="请输入客户电话" clearable size="small" />
          </el-form-item>
          <el-form-item label="订单类型：">
            <el-select v-model="query.orderType" placeholder="全部" clearable size="small">
              <el-option label="内购订单" :value="1" />
              <el-option label="售后退返订单" :value="2" />
              <el-option label="其他" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="query.orderPayType" placeholder="全部" clearable size="small">
              <el-option label="余额" :value="1" />
              <el-option label="零售价" :value="2" />
              <el-option label="学费" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="doQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="resetQuery" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right;">
        <el-button type="primary" @click="handleCreate" size="mini" icon="el-icon-plus" v-hasPermi="['order:outboundOrder:add']">新增订单</el-button>
      </div>
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="all" />
          <el-tab-pane :label="'待支付('+ counts[1] +')'" name="s1" />
          <el-tab-pane :label="'待审核('+ counts[2] +')'" name="s2" />
          <el-tab-pane :label="'待发货('+ counts[3] +')'" name="s3" />
          <el-tab-pane :label="'待收货('+ counts[4] +')'" name="s4" />
          <el-tab-pane :label="'已完成('+ counts[6] +')'" name="s6" />
          <el-tab-pane :label="'审核不通过('+ counts[5] +')'" name="s5" />
          <el-tab-pane :label="'已取消('+ counts[0] +')'" name="s0" />
        </el-tabs>
      </div>
      <el-table v-loading="loading" :data="tableData">
        <el-table-column prop="orderNum" label="订单编号" min-width="180" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{ row.orderNum }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="80">
          <template slot-scope="{row}">{{ row.orderType===2?'售后退返':(row.orderType===3?'其他':'内购') }}</template>
        </el-table-column>
        <el-table-column label="客户信息" min-width="160">
          <template slot-scope="{row}"><div class="tableDiv-txt">姓名:{{ row.customerName }}<br/>手机号:{{ row.customerPhone }}<br/>所属区域:{{ row.custProvince||'' }}{{ row.custCity||'' }}{{ row.custArea||'' }}</div></template>
        </el-table-column>
        <el-table-column label="状态" min-width="90">
          <template slot-scope="{row}">
            <el-tag :type="statusType(row.state)" size="small" :style="statusStyle(row.state)">{{ statusLabel(row.state) }}</el-tag>
            <el-tooltip v-if="row.state===5 && row.reviewRemark" :content="row.reviewRemark" placement="top">
              <i class="el-icon-info" style="color:#f56c6c;cursor:pointer" />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" min-width="70">
          <template slot-scope="{row}">{{ row.orderPayType===1?'余额':(row.orderPayType===2?'零售价':(row.orderPayType===3?'学费':'赠送')) }}</template>
        </el-table-column>
        <el-table-column label="价格明细" min-width="180">
          <template slot-scope="{row}">
            <div class="tableDiv-txt">
              <span>原价:{{ row.originalPrice || row.payTotalMoney }}</span>
              <span v-if="row.discountAmount">折扣:-{{ row.discountAmount }}</span>
              <span>商品:{{ row.payTotalMoney }}</span>
              <span>运费:{{ row.freight||0 }}</span>
              <span>应付:{{ row.allPayMoney }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="业务线" min-width="140">
          <template slot-scope="{row}">
            <div class="tableDiv-txt">
              <span v-if="row.custOneName">总监:{{ row.custOneName }}</span>
              <span v-if="row.custTwoName">经理:{{ row.custTwoName }}</span>
              <span v-if="row.custThreeName">大区:{{ row.custThreeName }}</span>
              <span v-if="row.custFourName">地区:{{ row.custFourName }}</span>
              <span v-if="row.custFiveName">县区:{{ row.custFiveName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="技术线" min-width="140">
          <template slot-scope="{row}">
            <div class="tableDiv-txt">
              <span v-if="row.techOneName">总监:{{ row.techOneName }}</span>
              <span v-if="row.techTwoName">督导:{{ row.techTwoName }}</span>
              <span v-if="row.techThreeName">技术老师:{{ row.techThreeName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalQuantity" label="总件数" min-width="60" />
        <el-table-column label="JST" min-width="60">
          <template slot-scope="{row}"><el-tag :type="row.isSendedJst===1?'success':'info'" size="small">{{ row.isSendedJst===1?'已推':'未推' }}</el-tag></template>
        </el-table-column>
        <el-table-column label="快递单号" min-width="130">
          <template slot-scope="{row}">
            <el-link v-if="row.logisticsNumber" type="primary" @click="lookLogistics(row)">{{ row.logisticsNumber }}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" min-width="150">
          <template slot-scope="{row}">{{ formatTime(row.payTime) }}</template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{row}">{{ formatTime(row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handlePay(row)" v-if="row.state===1" v-hasPermi="['order:outboundOrder:pay']" style="color:red">支付</el-button>
            <el-button type="text" @click="handleEdit(row)" v-if="row.state===1" v-hasPermi="['order:outboundOrder:edit']">编辑</el-button>
            <el-button type="text" @click="handleCopy(row)" v-hasPermi="['order:outboundOrder:copy']">复制</el-button>
            <el-button type="text" @click="handlePushJST(row)" v-if="row.state===3" v-hasPermi="['order:outboundOrder:push']">推送JST</el-button>
            <el-button type="text" @click="handleLogistics(row)" v-if="row.state===3||row.state===4" v-hasPermi="['order:outboundOrder:logistics']">同步快递单号</el-button>
            <el-button type="text" @click="handleSyncJst(row)" v-if="row.state===3&&row.isSendedJst===1" v-hasPermi="['order:outboundOrder:push']">同步JST</el-button>
            <el-button type="text" @click="handleCancel(row)" v-if="row.state!==4&&row.state!==6&&row.state!==0" v-hasPermi="['order:outboundOrder:cancel']" style="color:red">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQuery" />
    </el-card>

    <outbound-order-add ref="addDialog" :visible.sync="addVisible" @success="doQuery" />
    <logistics-details-vue ref="logisticsDetailsVue" />

    <!-- 支付弹窗 -->
    <el-dialog title="支付订单" :visible.sync="payVisible" width="500px">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="订单编号">{{ payForm.orderNum }}</el-descriptions-item>
        <el-descriptions-item label="订单类型">{{ payForm.orderType===2?'售后退返':(payForm.orderType===3?'其他':'内购') }}</el-descriptions-item>
        <el-descriptions-item label="客户姓名">{{ payForm.customerName }}</el-descriptions-item>
        <el-descriptions-item label="客户电话">{{ payForm.customerPhone }}</el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ payForm.orderPayType===1?'余额':(payForm.orderPayType===2?'零售价':(payForm.orderPayType===3?'学费':'赠送')) }}</el-descriptions-item>
        <el-descriptions-item label="应付金额"><b>{{ payForm.allPayMoney }}</b></el-descriptions-item>
        <el-descriptions-item label="商品总价">{{ payForm.payTotalMoney }}</el-descriptions-item>
        <el-descriptions-item label="商品总件数">{{ payForm.totalQuantity }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="payVisible = false">取消</el-button>
        <el-button type="primary" @click="doPay" :loading="payLoading">确认支付</el-button>
      </div>
    </el-dialog>

    <!-- 快递弹窗 -->
    <el-dialog title="同步快递单号" :visible.sync="logisticsVisible" width="400px">
      <el-form size="small">
        <el-form-item label="快递单号">
          <el-input v-model="logisticsForm.logisticsNumber" placeholder="留空则自动从聚水潭获取" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="logisticsVisible = false">取消</el-button>
        <el-button type="primary" @click="doLogistics">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderPage, cancelOrder, pushOrderToJst } from '@/api/order/outboundOrder'
import request from '@/utils/request'
import OutboundOrderAdd from './add.vue'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue'

export default {
  name: 'OutboundOrderList',
  components: { OutboundOrderAdd, logisticsDetailsVue },
  data() {
    return {
      loading: false, addVisible: false, payVisible: false, logisticsVisible: false, payLoading: false,
      activeName: 'all', dateTime: [],
      counts: {0:0,1:0,2:0,3:0,4:0,5:0,6:0},
      payForm: { id:undefined, orderNum:'', allPayMoney:0, orderPayType:1 },
      logisticsForm: { id:undefined, logisticsNumber:'' },
      query: { orderNum:'', customerName:'', customerPhone:'', state:undefined, orderType:undefined, orderPayType:undefined, startTime:'', endTime:'', pageNo:1, pageSize:20 },
      total: 0, tableData: []
    }
  },
  created() { this.doQuery() },
  methods: {
    doQuery() {
      this.loading = true
      getOrderPage(this.query).then(res => {
        if (res.code === '0') { this.tableData = res.data.list; this.total = res.data.total }
      }).finally(() => { this.loading = false; this.fetchCounts() })
    },
    fetchCounts() {
      const q = { ...this.query }; delete q.state
      Promise.all([1,2,3,4,5,6,0].map(s => getOrderPage({...q, state:s, pageNo:1, pageSize:1}))).then(rs => {
        const c = {}; rs.forEach((r, i) => { c[[1,2,3,4,5,6,0][i]] = r.code==='0'?r.data.total:0 })
        this.counts = c
      })
    },
    handleClick(tab) { this.query.state = tab.name==='all'?undefined:parseInt(tab.name.substring(1)); this.query.pageNo = 1; this.doQuery() },
    handleDateChange(v) { this.query.startTime = v?v[0]:''; this.query.endTime = v?v[1]:'' },
    resetQuery() { this.query = { orderNum:'', customerName:'', customerPhone:'', state:undefined, orderType:undefined, orderPayType:undefined, startTime:'', endTime:'', pageNo:1, pageSize:20 }; this.dateTime = []; this.activeName = ''; this.doQuery() },
    formatTime(v) { if (!v) return '-'; return v.replace('T',' ') },
    statusLabel(s) { const m={0:'已取消',1:'待支付',2:'待审核',3:'待发货',4:'待收货',5:'审核不通过',6:'已完成'}; return m[s]||s },
    statusType(s) { const m={0:'info',1:'warning',2:'warning',3:'',4:'success',5:'danger',6:'success'}; return m[s]||'info' },
    statusStyle(s) { return s===3 ? 'color:#409EFF;border-color:#409EFF' : null },
    handleShow(row) { this.$emit('handleShow', row, 2) },
    handleCreate() { this.$refs.addDialog.handleCreate() },
    handleEdit(row) { this.$refs.addDialog.handleCreate(row, true) },
    handleCopy(row) { this.$refs.addDialog.handleCreate(row, false) },
    handlePay(row) { this.payForm = { id:row.id, orderNum:row.orderNum, orderType:row.orderType, customerName:row.customerName, customerPhone:row.customerPhone, allPayMoney:row.allPayMoney, payTotalMoney:row.payTotalMoney, totalQuantity:row.totalQuantity, orderPayType:row.orderPayType }; this.payVisible = true },
    doPay() {
      this.payLoading = true
      request({ url:'/outbound/order/pay/'+this.payForm.id, method:'post' }).then(res => {
        if (res.code==='0') { this.$message.success('支付成功'); this.payVisible = false; this.doQuery() }
      }).finally(() => { this.payLoading = false })
    },
    handleReview(row, approve) {
      const txt = approve?'通过':'不通过'
      this.$confirm('确认审核'+txt+'?','提示',{type:'warning'}).then(() => {
        request({ url:'/outbound/order/review/'+(approve?'approve':'reject')+'/'+row.id, method:'post' }).then(res => {
          if (res.code==='0') { this.$message.success('审核'+txt); this.doQuery() }
        })
      }).catch(()=>{})
    },
    handlePushJST(row) {
      this.$confirm('确认推送JST?','提示').then(() => {
        pushOrderToJst(row.id).then(res => { if (res.code==='0') { this.$message.success('推送成功'); this.doQuery() } })
      }).catch(()=>{})
    },
    handleLogistics(row) { this.logisticsForm = { id:row.id, logisticsNumber:row.logisticsNumber||'' }; this.logisticsVisible = true },
    doLogistics() {
      const params = {}
      if (this.logisticsForm.logisticsNumber) params.logisticsNumber = this.logisticsForm.logisticsNumber
      request({ url:'/outbound/order/logistics/'+this.logisticsForm.id, method:'put', params }).then(res => {
        if (res.code==='0') { this.$message.success('同步成功:'+(res.data||'')); this.logisticsVisible = false; this.doQuery() }
      })
    },
    lookLogistics(row) {
      const pho = row.customerPhone || ''
      const str = pho ? `:${pho.trim().slice(-4)}` : ''
      this.$refs.logisticsDetailsVue.handleShow(row.logisticsNumber + str)
    },
    handleSyncJst(row) {
      request({ url:'/outbound/order/syncJst/'+row.id, method:'post' }).then(res => {
        if (res.code==='0') { this.$message.success('同步完成'); this.doQuery() }
      })
    },
    handleCancel(row) {
      const msgs = { 1:'确定取消该订单？', 2:'取消将退回已支付款项，确定？', 3:'取消将退回款项'+(row.isSendedJst===1?'并同步取消JST订单':'')+'，确定？', 5:'确定取消该订单？' }
      this.$confirm(msgs[row.state]||'确定取消？','提示',{type:'warning'}).then(() => {
        cancelOrder(row.id).then(res => { if (res.code==='0') { this.$message.success('取消成功'); this.doQuery() } })
      }).catch(()=>{})
    }
  }
}
</script>
<style lang="scss" scoped>
.tableDiv-txt {
  display: flex;
  flex-direction: column;
}
</style>
